export default __webpack_public_path__ + "static/media/minusNoQuantityIcon.775cf37d.svg";